(() => {
  const filterMenu = document.querySelector('.Filters-Wrapper .BubbleBox');
  if (filterMenu === null) return;

  function toggleFilterMenu() {
    if (window.matchMedia('(max-width: 960px)').matches) {
      filterMenu.parentElement.classList.toggle('is-open');
    }
  }

  filterMenu.addEventListener('click', toggleFilterMenu, false);
})();
